import React from 'react';
import { Card } from 'antd';
import { Typography } from 'components/common';
import { CallIncomingIcon, CallOutgoingIcon } from 'assets';
import { Utils } from 'utils';
import { CALL_STATUS_COLORS, CARD_STYLES, ICON_STYLES } from './constants';

interface CallHistoryCardProps {
  record: any;
  extensions: any[];
  index: number;
}

const CallHistoryCard: React.FC<CallHistoryCardProps> = ({ record, extensions, index }) => {
  const extension = record?.user_ext || null;
  const isInbound = record.call_direction === 'inbound';
  const isOutbound = record.call_direction === 'outbound';

  return (
    <Card
      key={index}
      size="small"
      style={CARD_STYLES}
      bordered
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src={isOutbound ? CallOutgoingIcon : CallIncomingIcon}
            alt={isOutbound ? "outgoing" : "incoming"}
            style={ICON_STYLES}
          />
          <span>
            {Utils.formatDateTime(record.start_timestamp)} — {isInbound ? 'Incoming' : 'Outgoing'}
          </span>
        </div>
      }
    >
      <div className="call-history-item">
        <div style={{ marginBottom: '8px' }}>
          {record.missed_call ? (
            <Typography variant="small-heading-3" style={{ color: CALL_STATUS_COLORS.missed }}>
              <strong>Status:</strong> {isInbound ? 'Missed' : "Unanswered"}
            </Typography>
          ) : (
            <Typography variant="small-heading-3" style={{ color: CALL_STATUS_COLORS.answered }}>
              <strong>Status:</strong> Answered
            </Typography>
          )}
        </div>

        <div>
          <Typography variant="small-heading-3">
            <strong>Duration:</strong> {Utils.formatCallDuration(record.duration)}
          </Typography>
        </div>

        {/* Extension / Last Destination */}
        {extension && (
          <div>
            <Typography variant="small-heading-3">
              <strong>Extension:</strong> {extension}
            </Typography>
          </div>
        )}

        {isInbound && !extension && record?.dialed_number &&
          <div>
            <Typography variant="small-heading-3">
              <strong>Dialed Number:</strong> {record?.dialed_number}
            </Typography>
          </div>
        }

        {isOutbound && !extension && record?.caller_id_number &&
          <div>
            <Typography variant="small-heading-3">
              <strong>Caller ID:</strong> {record?.caller_id_number}
            </Typography>
          </div>
        }

        {record.call_flow && record.call_flow.length > 0 && (
          <div style={{ marginTop: '12px' }}>
            <Typography variant="small-heading-3">
              <strong>Call Flow:</strong>
            </Typography>
            <div style={{ marginLeft: '12px', marginTop: '4px' }}>
              {record.call_flow.map((flow: any, flowIdx: number) => (
                <div key={flowIdx} style={{ marginBottom: '4px' }}>
                  <Typography variant="body-text-3">
                    {flow.callcenter ? (
                      `• Call Center: Agent ${flow.callcenter.agentNumber || 'Unknown'}`
                    ) : flow.ivr ? (
                      `• IVR: ${flow.ivr.menu || 'Menu'}`
                    ) : flow.queue ? (
                      `• Queue: ${flow.queue.name || 'Unknown Queue'}`
                    ) : (
                      `• ${Object.keys(flow)[0] || 'Unknown'}: ${Object.values(flow)[0] || ''}`
                    )}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default CallHistoryCard;
